import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=3789bb28&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=3789bb28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3789bb28",
  null
  
)

export default component.exports